import logger from "@/services/Logger";

import addToQueue from "./actions/addToQueue";
import removeFromQueue from "./actions/removeFromQueue";
import clearQueue from "./actions/clearQueue";
import createPlaylist from "./actions/createPlaylist";
import savePlaylist from "./actions/savePlaylist";
import addToPlaylist from "./actions/addToPlaylist";
import removeFromPlaylist from "./actions/removeFromPlaylist";
import complain from "./actions/complain";

const actionsLib = {
  addToQueue,
  removeFromQueue,
  clearQueue,
  addToPlaylist,
  createPlaylist,
  savePlaylist,
  removeFromPlaylist,
  complain
};

const contextMenu = {
  create(list) {
    return Object.keys(list)
      .reduce((items, name) => {
        if (actionsLib[name]) {
          const item = actionsLib[name](list[name]);
          const isArray = Array.isArray(item);

          return isArray ? [...items, ...item] : [...items, item];
        } else {
          return logger.error(`Context menu item "${name}" not found`), null;
        }
      }, [])
      .filter(item => item !== null && item.active);
  }
};

contextMenu.plugin = {
  install(app) {
    app.prototype.$contextMenu = contextMenu;
  }
};

export default contextMenu;
